/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Club_OneInputs */

const en_platform_team_club_one = /** @type {(inputs: Platform_Team_Club_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole team on one page`)
};

const pl_platform_team_club_one = /** @type {(inputs: Platform_Team_Club_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały zespół na jednej stronie`)
};

/**
* | output |
* | --- |
* | "The whole team on one page" |
*
* @param {Platform_Team_Club_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_club_one = /** @type {((inputs?: Platform_Team_Club_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Club_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_club_one(inputs)
	return en_platform_team_club_one(inputs)
});